import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface AITextAnalyzerConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const AITextAnalyzerConfig: React.FC<AITextAnalyzerConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="AI Szöveg Elemző">
        <ConfigField
          label="Szöveg"
          description="Az elemzendő szöveg"
        >
          <textarea
            value={node.data.config?.text || ''}
            onChange={(e) => updateConfig('text', e.target.value)}
            placeholder="{{customer_feedback}} vagy közvetlen szöveg..."
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Elemzés típusa"
          description="Mit elemezzen"
        >
          <select
            value={node.data.config?.analysisType || 'sentiment'}
            onChange={(e) => updateConfig('analysisType', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="sentiment">Hangulatelemzés (pozitív/negatív)</option>
            <option value="keywords">Kulcsszavak kinyerése</option>
            <option value="entities">Entitások felismerése</option>
            <option value="topics">Témák azonosítása</option>
            <option value="language">Nyelv felismerés</option>
            <option value="toxicity">Toxicitás elemzés</option>
          </select>
        </ConfigField>

        <ConfigField
          label="AI Provider"
          description="Melyik AI szolgáltatást használja"
        >
          <select
            value={node.data.config?.provider || 'openai'}
            onChange={(e) => updateConfig('provider', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="openai">OpenAI</option>
            <option value="claude">Claude</option>
            <option value="gemini">Gemini</option>
          </select>
        </ConfigField>

        <ConfigField
          label="API Kulcs"
          description="AI szolgáltatás API kulcsa"
        >
          <input
            type="password"
            value={node.data.config?.apiKey || ''}
            onChange={(e) => updateConfig('apiKey', e.target.value)}
            placeholder="sk-..."
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>
      </ConfigSection>

      <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-md p-3">
        <div className="text-xs text-purple-700 dark:text-purple-300">
          <strong>🤖 AI Szöveg Elemzés:</strong>
          <br />• Automatikus szöveg elemzés AI-val
          <br />• Eredmény: <code>{'{{analysis}}'}</code>
          <br />• Példa: Ügyfél visszajelzés hangulata
        </div>
      </div>
    </div>
  );
};

export default AITextAnalyzerConfig;
